module.exports = __webpack_public_path__ + "static/media/parking.6870c2af.png";